import request from '@/router/axios';

// export const getMessageList = (getData) => {
//     return request({
//       url: '/api/v4ward/message/notify/more',
//       method: 'get',
//       params: getData,
//     });
//   };
// 获取消息通知列表
  export const getMessageList = (getData) => {
    return request({
      url: '/api/v4ward/message/notify/messageDialogList',
      method: 'get',
      params: getData,
    });
  };
// 读取全部消息
  export const updateBatchStatus = (getData) => {
    return request({
      url: '/api/v4ward/message/notify/updateBatchStatus',
      method: 'post',
      params: getData,
    });
  };
// 读取全部消息
export const messageDialogSum = (getData) => {
  return request({
    url: '/api/v4ward/message/notify/messageDialogSum',
    method: 'get',
    params: getData,
  });
};

// 获取各个类型消息通知未读数量
export const getAllMessageTypeSum = (getData) => {
  return request({
    url: '/api/v4ward/message/notify/messageTypeSum',
    method: 'get',
    params: getData,
  });
};

// 改变消息已读未读状态
export const updateMeassageStatus = (getData) => {
  return request({
    url: '/api/v4ward/message/notify/updateStatus',
    method: 'post',
    params: getData,
  });
};
  export const getMessageDetail = (getData) => {
    return request({
      url: '/api/v4ward/message/notify/read',
      method: 'get',
      params: getData,
    });
  };

